module.exports = {
  /**
   * SEO
   */
  blogTitle: "UnableRegister's Blog",
  blogDescription: "UnableRegister's Blog",
  blogAuthor: 'UnableRegister',
  blogKeywords: 'UnableRegister, UnableRegister\'Blog, vue, vue-blog, GitHub-page, 博客',
  favicon: './src/assets/favicon.png',

  /**
   * GitHub
   */
  repo: 'UnableRegister/blog-article',
  path: '',
  branch: 'master',
}


// WEBPACK FOOTER //
// ./src/siteConfig.js